import { useEffect } from 'react';
import { useAuth } from '../features/auth/AuthProvider';
import { api } from './api';

const BEAT_EVERY = 30_000;

/**
 * Random id for this page while it's open, so the admin panel can count visitors without an
 * account. Kept in memory only: nothing is stored on the device and it dies with the tab.
 */
const visitorId =
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : '00000000-0000-4000-8000-000000000000'.replace(/0/g, () =>
        Math.floor(Math.random() * 16).toString(16),
      );

/** Tells the server this page is open (signed in or not) every 30 s, for the online counter. */
export function PresenceHeartbeat(): null {
  const { status } = useAuth();

  useEffect(() => {
    if (status === 'loading') return;
    const beat = () => {
      const request =
        status === 'authenticated' ? api.presence.heartbeat() : api.presence.visitor(visitorId);
      void request.catch(() => undefined);
    };
    beat();
    const timer = setInterval(beat, BEAT_EVERY);
    return () => clearInterval(timer);
  }, [status]);

  return null;
}
